import type { ReactNode } from 'react'

type Props = {
  readonly children: ReactNode
}

export function Benefits({ children }: Props) {
  return (
    <div className="flex justify-center">
      <ul
        className="my-2 px-0 list-none flex flex-col lg:flex-row justify-center text-lg lg:text-xl gap-1 lg:gap-4"
        aria-labelledby="business-plan-benefits-title"
      >
        {children}
      </ul>
    </div>
  )
}
